import Expander from '../Expander'
import Text, { HeaderText } from '../Text'
import React from 'react'
import { Container } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import Flex from 'typescript-styled-flex'
import ActionButton from '../ActionButton'
import sendErrorNotificationMessage from '../../../actions/notification/sendError'
import { useDispatch, useSelector } from 'react-redux'
import {
  getUserEmail,
  getUserId,
} from '../../../reducers/userAccount/selectors/userAccount'

export default function(notification, size = 1) {
  const { t } = useTranslation()
  const user = useSelector(getUserId)
  const email = useSelector(getUserEmail)
  const dispatch = useDispatch()

  function action() {
    dispatch(
      sendErrorNotificationMessage(
        'booking_sync_errors@bed-booking.com',
        'AIRBNB IMPORT ERROR',
        `User ID: ${user}\n` +
          `Email: ${email}\n` +
          `Error message: ${t('OUT_28_airbnb_import_error')}\n\n` +
          `Job Payload: \n` +
          `${t('OUT_28_airbnb_import_error_message')} \n \n`,
        notification.id,
      ),
    )
  }

  return (
    <Expander size={size} id={notification.id}>
      <Text size={size}>
        <HeaderText size={size}>
          <Flex row={true} justifyBetween={true} alignStart={true}>
            {t('OUT_28_airbnb_import_error')}
            <ActionButton
              size={size}
              style={{ marginTop: 0, paddingLeft: `${10 * size}px` }}
              label={
                notification.sending === 2 ? t('BBO_3136_sent') : t('send')
              }
              sending={notification.sending}
              action={action}
            />
          </Flex>
        </HeaderText>
        <Container style={{ padding: '0' }}>
          {t('OUT_28_airbnb_import_error_message')}
        </Container>
      </Text>
    </Expander>
  )
}
